import { ScheduleTopmost } from "routes/schedule/scheduleIntroduction"
import { NewScheduleMetadataFields } from "authoring/routes/project/schedule-editor/components/new-schedule-metadata-fields"

ScheduleTopmost.plug(<NewScheduleMetadataFields if={(context) => !!context.isAuthoringScheduleEditor} priority={0} />)
